<template>
    <div class="products-content">
        <div class="title" v-if="blockdatas.globalLink.label">
            <a v-if="blockdatas.globalLink.link" :href="blockdatas.globalLink.link">{{ blockdatas.globalLink.label }}</a>
            <p v-else>{{ blockdatas.globalLink.label }}</p>
        </div>
    
        <!--  --------------------------------------
                Dynamic Button for univers
        ---------------------------------------  -->
        <div class="btn-container">
            <!-- All top Products -->
            <div
                @click="filterProductList('all')"
                class="btn-productType"
                :class="buttonActive === 'all' ? 'active' : ''"
            >
                Tous les produits
            </div>
            
            <!-- By Univers top Products -->
            <div 
                v-for="key in universeFiltered"
                @click="filterProductList(key[0])"
                :key="key"
                class="btn-productType"
                :class="buttonActive === key[0] ? 'active' : ''"
            >
                {{key[0]}}
            </div>
        </div>

        <!--  --------------------------------------
                Dynamic Carouel for univers
        ---------------------------------------  -->
        <div class="products-list row">
            <VueSlickCarousel v-bind="settingsForCart" v-if="filteredProducts && filteredProducts.length > 0">
                <ProductItemCard
                    v-for="(product, key) in filteredProducts"
                    :key="key"
                    :product="product"
                    :positionInList="key+1"
                    class="item-product item"
                /> 
            </VueSlickCarousel>
        </div>
        
    </div>
</template>

<script>
import ProductItemCard from "@/includes/Product/ProductItemCard/ProductItemCard.vue";
import VueSlickCarousel from "vue-slick-carousel";
import galleryMixin from "@/mixins/galleryMixin";

export default {
    name: "PushForwardProducts",

    mixins: [galleryMixin],

    components: { 
        ProductItemCard,
        VueSlickCarousel
    },

    props: ["blockdatas"],

    data() {
        return {    
            filteredProducts: this.blockdatas.products,
            buttonActive: 'all',
            universeFiltered: null,
        };
    },

    methods: {
        async filterProductList(attr) {
            this.filteredProducts = [];
            
            await this.$nextTick(() => {
                if(attr === 'all') {
                    this.filteredProducts = this.blockdatas.products;
                } else {
                this.filteredProducts = this.universeFiltered.get(attr); 
                }
                
                this.setActiveButton(attr) 
            })
           
        },

        setActiveButton(productId) {
            this.buttonActive = productId;
        },

        filterByUniverse(data) {
            let productFilteredByUniverse = new Map();

            for (let i = 0; i < data.length; i++) {
                if(!productFilteredByUniverse.has(data[i].productUnivers)) {
                    let map_name = data[i].productUnivers;
                    let map_value = [];
                    map_value.push(data[i]);
                    productFilteredByUniverse.set(map_name, map_value);
                } else {
                    productFilteredByUniverse.get(data[i].productUnivers).push(data[i]);
                }
            }

            this.universeFiltered = productFilteredByUniverse;
        }
    },

    created() {
        this.filterByUniverse(this.blockdatas.products);
    },
    
    

};
</script>

<style lang="scss" >
.zblock_push_forward_products{

    div.title{
        text-align: center;

        a,
        p{
            font-size: 3rem;
            font-weight: 800; 
        }
        
    }
    
    //Button types product
    .btn-container {
        text-align: center;
        margin: 35px auto;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;


        .btn-productType {
            cursor: pointer;
            margin: 10px 20px;
            padding: 13px 20px;
            border-radius: 22px;
            background-color: #FAFAFA;
            font-size: 1.8rem;

            &:hover,
            &.active {
                color: $color-red;
            }

            &.active {
                font-weight: 800;
            }
        }
    }

    .products-list.row {
        min-height: 550px;
        /* fix for rating popin
        .item-product {
            padding-bottom: 230px;
        } */
    }

    //Carousel
    .slick-slider {
        width: 100%;
        max-width: 90vw;
        margin: 0 auto;
    }

    .slick-slider .slick-prev {
        left: -5vw;
    }

    #app .slick-slider .slick-arrow.slick-next {
        right: -2vw;
    }

    //fix for rating popin
    .slick-slider .popin-ratings {
        top: -300px;
    }
}
</style>
